import { getToken } from '@api/config';
import { createHeaders } from '@api/httpHeaderConfig';
import { axiosFetchHandler } from './configs/fetchWrapper';

export const clearAllCookies = () => {
  // Get all cookies
  const cookies = document.cookie.split(';');

  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

    // Skip if empty name
    if (!name) return;

    // Array of possible domain and path combinations
    const clearOptions = [
      // Current domain, root path
      { domain: '', path: '/' },
      { domain: '', path: '' },

      // Current hostname
      { domain: window.location.hostname, path: '/' },
      { domain: window.location.hostname, path: '' },

      // With leading dot for current hostname
      { domain: `.${window.location.hostname}`, path: '/' },
      { domain: `.${window.location.hostname}`, path: '' },
    ];

    // Add parent domain options if on subdomain
    const hostParts = window.location.hostname.split('.');
    if (hostParts.length > 2) {
      const parentDomain = hostParts.slice(-2).join('.');
      clearOptions.push(
        { domain: `.${parentDomain}`, path: '/' },
        { domain: `.${parentDomain}`, path: '' },
        { domain: parentDomain, path: '/' },
        { domain: parentDomain, path: '' },
      );
    }

    // Try to clear cookie with all possible combinations
    clearOptions.forEach(({ domain, path }) => {
      let cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;

      if (path) cookieString += `path=${path};`;
      if (domain) cookieString += `domain=${domain};`;

      document.cookie = cookieString;
    });

    // Also try with SameSite=None for cross-site cookies
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=None;Secure`;
  });

  // Clear localStorage and sessionStorage as well
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (e) {
    console.warn('Could not clear storage:', e);
  }
};

export const clearAppCookies = () => {
  const appCookieNames = [
    '_ga',
    '_ga_NZMZRCJOC8',
    'ar_debug',
    'next-auth.callback-url',
    'next-auth.csrf-token',
    'jwt',
    // Add your specific cookie names here
  ];

  appCookieNames.forEach((name) => {
    // Try multiple domain/path combinations
    [
      `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`,
      `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`,
      `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`,
    ].forEach((cookieString) => {
      document.cookie = cookieString;
    });
  });
};

export const logoutAuthenticatedUserV2 = async () => {
  const response = await axiosFetchHandler(`${process.env.REACT_APP_API_URL}/auth/logout`, {
    headers: createHeaders({ Authorization: `Bearer ${getToken()}` }),
  });

  // Clear authentication data and cookies regardless of response status
  await clearAuthenticationData();
  await clearAllCookies();
  await clearAppCookies();

  // Redirect to login on API failure
  if (!response.ok) {
    redirectToLogin();
  }

  return { isSuccessful: true };
};

export const clearAuthenticationData = async () => {
  await localStorage.clear();
  await localStorage.removeItem('redirectPath');
};

export const redirectToLogin = () => {
  window.location.href = '/login?action=logout';
};
